export const SupportPhone = "+972586795579";

export const WhatsappSupportUrl = "https://wa.me/972586795579";

export const smapySignature = "צוות סמאפי";
